//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import range from 'lodash/fp/range';
import NcsFilter from './NcsFilter';
export default {
  "extends": NcsFilter,
  props: {
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    firstAsAny: {
      type: Boolean,
      "default": false
    },
    reverse: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    options: function options() {
      return this.reverse ? range(this.max, this.min - 1) : range(this.min, this.max + 1);
    }
  }
};